import React, { useState, useEffect } from 'react'
import Wrapper from '../../components/Wrapper'
import { useNavigate } from 'react-router-dom'
import ShortTable from '../../components/new_component/ShortTable'

import { menu, input, sip, short, group as groupTranslate } from '../../translate'
import Api from '../../Api'
import { toast } from 'react-toastify'

function Groups() {
  const navigate = useNavigate()
  const langIndex = +localStorage.getItem('atsLang') || 1
  const [viewMode, setViewMode] = useState('table')
  const [groups, setGroups] = useState([])
  const [filteredGroups, setFilteredGroups] = useState([])
  const [loading, setLoading] = useState(false)
  const [searchQuery, setSearchQuery] = useState('')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(9)
  const [telegram, setTelegram] = useState([])
  const [whatsapp, setWhatsapp] = useState([])
  useEffect(() => {
    fetchGroups()
  }, [viewMode])

  useEffect(() => {
    if (searchQuery) {
      const query = searchQuery.toLowerCase()
      const filtered = groups.filter(group => {
        const searchableFields = [
          group.name,
          group.virtual,
          group.noaction,
          group.cwaiting,
        ]
        return searchableFields.some(field =>
          field !== null &&
          field !== undefined &&
          String(field).toLowerCase().includes(query)
        )
      })
      setFilteredGroups(filtered)
    } else {
      setFilteredGroups(groups)
    }
    setPage(0) // Reset to first page when filter changes
  }, [searchQuery, groups])

  const fetchGroups = async () => {
    setLoading(true)
    try {
      const response = await Api.groupsGet()
      if (response?.data?.status === 'ok') {
        const shortGroups = response.data.data || []
        const telegramList = response.data.telegram || []
        const whatsappList = response.data.whatsapp || []
        const allGroups = shortGroups.map(g => {
          const virtual = g.virtual != null ? String(g.virtual) : ''
          const hasTelegram = telegramList.some(t => (t.group_id != null ? String(t.group_id) : '') === virtual)
          const hasWhatsapp = whatsappList.some(w => (w.group_id != null ? String(w.group_id) : '') === virtual)
          return { ...g, type: 'short', telegram: !!hasTelegram, whatsapp: !!hasWhatsapp }
        })
        setGroups(allGroups)
        setFilteredGroups(allGroups)
        setTelegram(telegramList)
        setWhatsapp(whatsappList)
      }
    } catch (error) {
      console.error('Error fetching groups:', error)
    } finally {
      setLoading(false)
    }
  }



  const handleViewModeChange = (event, newViewMode) => {
    if (newViewMode !== null) {
      setViewMode(newViewMode)
    }
  }



  return (
    <Wrapper>
      {viewMode === 'table' ? (
        <>
          <ShortTable data={groups} telegram={telegram} whatsapp={whatsapp} setData={setGroups} loading={loading} title={menu.group[langIndex]} viewMode={viewMode} onViewModeChange={handleViewModeChange} />
        </>
      ) : (
        <div className="tableParent">
         
        </div>
      )}
    </Wrapper>
  )
}

export default Groups